/**
 * @file assets/kumak-upsell-brosse.js
 * @description Suggestion « brosse » : après l'ajout d'un SIDEM sans brosse, un petit panneau propose la brosse visage solo. Configuration lue dans #kub-config (rendue par snippets/kumak-upsell-brosse.liquid).
 * @status Pré-prod 208086401366 (2026-10-02). Corrigé le 02/10 (mission correcteur) : attend la fin du choix cookies, annonce lecteur d'écran après insertion, Échap limitée au panneau.
 * @issues Le tiroir panier est rafraîchi par l'événement cart:update du thème (Horizon/Pitch) ; si le thème change de mécanique, l'ajout fonctionne quand même mais le compteur ne se met à jour qu'au rechargement.
 * @todo None
 */

const CONFIG_EL = document.getElementById('kub-config');
const SESSION_KEY = 'kumak_upsell_brosse_vu';

// Sous l'éditeur de thème, on ne veut pas qu'un ajout de test fasse surgir le panneau.
if (CONFIG_EL && !(window.Shopify && window.Shopify.designMode)) init();

function init() {
  let config;
  try {
    config = JSON.parse(CONFIG_EL.textContent);
  } catch (error) {
    console.error('[kumak-upsell-brosse] configuration illisible', error);
    return;
  }
  const sansBrosse = new Set(config.sidemSansBrosse.map(String));
  const avecBrosse = new Set(config.avecBrosse.map(String));

  document.addEventListener('cart:update', (event) => {
    const data = (event.detail && event.detail.data) || {};
    // Seul un ajout volontaire depuis une fiche compte : on ignore les changements de quantité du tiroir et nos propres ajouts.
    if (data.source !== 'product-form-component' || data.didError) return;
    if (String(data.productId) !== String(config.sidemProductId)) return;
    if (dejaVu()) return;
    verifierPanier(config, sansBrosse, avecBrosse);
  });
}

function dejaVu() {
  try {
    return sessionStorage.getItem(SESSION_KEY) === '1';
  } catch (error) {
    return false; // Stockage bloqué (navigation privée stricte) : on reste utile, au pire le panneau revient.
  }
}

function marquerVu() {
  try {
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch (error) {
    /* stockage indisponible : sans conséquence */
  }
}

async function verifierPanier(config, sansBrosse, avecBrosse) {
  let cart;
  try {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('HTTP ' + response.status);
    cart = await response.json();
  } catch (error) {
    console.error('[kumak-upsell-brosse] lecture du panier impossible', error);
    return;
  }
  const ids = cart.items.map((item) => String(item.variant_id));
  const aSidemSeul = ids.some((id) => sansBrosse.has(id));
  const aDejaBrosse = ids.some((id) => avecBrosse.has(id));
  if (!aSidemSeul || aDejaBrosse) return;
  marquerVu();
  quandBanniereCookiesFermee(() => afficherPanneau(config));
}

// Bannière de consentement aux cookies de Shopify : sur mobile, le panneau la recouvrait et masquait son texte.
// On attend qu'elle soit fermée (même test que busy() dans kumak-preuve-commandes).
function banniereCookiesVisible() {
  const banniere = document.getElementById('shopify-pc__banner');
  return Boolean(banniere && banniere.getClientRects().length && getComputedStyle(banniere).visibility !== 'hidden');
}

function quandBanniereCookiesFermee(suite) {
  if (!banniereCookiesVisible()) {
    suite();
    return;
  }
  const verifier = setInterval(() => {
    if (banniereCookiesVisible()) return;
    clearInterval(verifier);
    // Court répit après le clic sur la bannière, pour que le panneau ne surgisse pas dans le même geste.
    setTimeout(suite, 600);
  }, 500);
}

// Un autre dialogue ouvert (pop-up Society, avis complet, tiroir…) garde la main sur la touche Échap.
function autreDialogueOuvert(panneau) {
  if (document.querySelector('dialog[open], #kpop.is-open')) return true;
  const modal = document.querySelector('[aria-modal="true"]');
  return Boolean(modal && !panneau.contains(modal) && modal.getClientRects().length);
}

// Bas d'écran, mais au-dessus du bouton « Chat » (Shopify Inbox, ~88-138 px du bas) et de la bulle « Besoin d'aide ? » pour ne masquer ni l'un ni l'autre.
const CSS = `
.kub{position:fixed;z-index:2147481001;left:12px;right:12px;bottom:calc(150px + env(safe-area-inset-bottom));
  background:#FFFAF7;color:#3A2A22;border:1px solid rgba(58,42,34,.14);border-radius:14px;
  box-shadow:0 10px 30px rgba(58,42,34,.18);padding:14px 44px 14px 14px;font-size:.9rem;line-height:1.35;
  transform:translateY(16px);opacity:0;transition:transform .28s ease,opacity .28s ease}
.kub.is-in{transform:none;opacity:1}
.kub [hidden]{display:none!important}
.kub__row{display:flex;gap:12px;align-items:center}
.kub__img{width:64px;height:64px;flex:0 0 64px;border-radius:10px;object-fit:cover;background:#F3E9E2}
.kub__txt{margin:0}
.kub__titre{display:block;font-weight:600}
.kub__prix{display:block;margin-top:2px;font-weight:600}
.kub__actions{display:flex;gap:8px;align-items:center;margin-top:12px;flex-wrap:wrap}
.kub__btn{min-height:44px;padding:0 18px;border-radius:999px;border:0;background:#3A2A22;color:#FFFAF7;font:inherit;font-weight:600;cursor:pointer}
.kub__btn[disabled]{opacity:.6;cursor:progress}
.kub__non{min-height:44px;padding:0 10px;border:0;background:none;color:#3A2A22;font:inherit;text-decoration:underline;cursor:pointer}
.kub__x{position:absolute;top:6px;right:6px;width:36px;height:36px;border:0;background:none;color:#3A2A22;font-size:22px;line-height:1;cursor:pointer;border-radius:50%}
.kub button:focus-visible,.kub a:focus-visible{outline:2px solid #3A2A22;outline-offset:2px}
.kub__msg{margin:10px 0 0}
.kub__msg a{color:inherit}
.kub__annonce{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}
@media (min-width:750px){.kub{left:auto;right:20px;width:340px}}
@media (prefers-reduced-motion:reduce){.kub{transition:none;transform:none}}
`;

function afficherPanneau(config) {
  if (document.querySelector('.kub')) return;
  const style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  const panneau = document.createElement('aside');
  panneau.className = 'kub';
  panneau.setAttribute('role', 'region');
  panneau.setAttribute('aria-label', 'Suggestion : brosse visage en silicone');
  panneau.innerHTML = `
    <div class="kub__row">
      ${config.image ? `<img class="kub__img" src="${config.image}" alt="${echapper(config.imageAlt)}" width="64" height="64" loading="lazy">` : ''}
      <p class="kub__txt">
        <span class="kub__titre">Pour faire mousser SIDEM : la brosse visage en silicone douce</span>
        <span class="kub__prix">${echapper(config.prix)}</span>
      </p>
    </div>
    <div class="kub__actions">
      <button type="button" class="kub__btn">Ajouter la brosse</button>
      <button type="button" class="kub__non">Non merci</button>
    </div>
    <p class="kub__msg" hidden></p>
    <p class="kub__annonce" aria-live="polite"></p>
    <button type="button" class="kub__x" aria-label="Fermer la suggestion">&times;</button>`;
  document.body.appendChild(panneau);
  // Double rAF : laisse le navigateur peindre l'état initial pour que la transition d'entrée joue.
  requestAnimationFrame(() => requestAnimationFrame(() => panneau.classList.add('is-in')));

  // Une région live déjà remplie à son insertion n'est pas lue par la plupart des lecteurs d'écran :
  // on l'insère vide, puis on y écrit le texte une fois qu'elle est dans la page.
  const annonce = panneau.querySelector('.kub__annonce');
  const annoncer = (texte) => {
    annonce.textContent = '';
    setTimeout(() => {
      annonce.textContent = texte;
    }, 150);
  };
  annoncer(`Suggestion : la brosse visage en silicone douce, ${config.prix}.`);

  const bouton = panneau.querySelector('.kub__btn');
  const message = panneau.querySelector('.kub__msg');
  let minuterie;

  const onKey = (event) => {
    if (event.key !== 'Escape') return;
    // Échap ferme le panneau si la cliente est dedans, ou si aucun autre dialogue n'attend cette touche.
    if (panneau.contains(document.activeElement) || !autreDialogueOuvert(panneau)) fermer();
  };
  function fermer() {
    clearTimeout(minuterie);
    document.removeEventListener('keydown', onKey);
    panneau.classList.remove('is-in');
    const retirer = () => panneau.remove();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) retirer();
    else setTimeout(retirer, 300);
  }
  document.addEventListener('keydown', onKey);
  panneau.querySelector('.kub__x').addEventListener('click', fermer);
  panneau.querySelector('.kub__non').addEventListener('click', fermer);

  bouton.addEventListener('click', async () => {
    bouton.disabled = true;
    bouton.textContent = 'Ajout…';
    try {
      await ajouterBrosse(config.brosseVariantId);
      panneau.querySelector('.kub__actions').hidden = true;
      message.hidden = false;
      message.innerHTML = 'Brosse ajoutée à votre panier. <button type="button" class="kub__non">Voir le panier</button>';
      annoncer('Brosse ajoutée à votre panier.');
      message.querySelector('button').addEventListener('click', () => {
        fermer();
        const tiroir = document.querySelector('cart-drawer-component');
        if (tiroir && typeof tiroir.open === 'function') tiroir.open();
        else window.location.href = '/cart';
      });
      // On laisse le temps de lire, sauf si la cliente est en train d'interagir avec le panneau.
      minuterie = setTimeout(() => {
        if (!panneau.contains(document.activeElement)) fermer();
      }, 7000);
    } catch (error) {
      console.error('[kumak-upsell-brosse] ajout impossible', error);
      bouton.disabled = false;
      bouton.textContent = 'Ajouter la brosse';
      message.hidden = false;
      message.innerHTML = `La brosse n'a pas pu être ajoutée. <a href="${echapper(config.url)}">Voir sa fiche</a>`;
      annoncer("La brosse n'a pas pu être ajoutée.");
    }
  });
}

async function ajouterBrosse(variantId) {
  // On demande au passage le HTML des sections du tiroir pour que le thème le rafraîchisse sans recharger la page.
  const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId);
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || result.status) throw new Error(result.description || 'HTTP ' + response.status);

  const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  await notifierTheme(cart.item_count, result.sections || {});
}

async function notifierTheme(itemCount, sections) {
  // source ≠ « product-form-component » : la pastille du panier remplace son total au lieu de l'additionner.
  const data = { source: 'kumak-upsell', itemCount, sections };
  let evenement;
  try {
    const { CartUpdateEvent } = await import('@theme/events');
    evenement = new CartUpdateEvent({}, 'kumak-upsell', data);
  } catch (error) {
    // Import map absente ou renommée : on reproduit la forme de l'événement du thème.
    evenement = new Event('cart:update', { bubbles: true });
    evenement.detail = { resource: {}, sourceId: 'kumak-upsell', data };
  }
  document.dispatchEvent(evenement);
}

function echapper(texte) {
  return String(texte ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
}
